<template>
  <div>
    <div class="btn-view">
      <div class="from-view">
        <div class="from-label">{{ $t('device.device.023557-0') }}</div>
        <Input :placeholder="$t('device.device.023557-1')" v-model="query.mobile"></Input>
      </div>
      <div class="from-view">
        <div class="from-label">{{ $t('device.device.023557-2') }}</div>
        <Input :placeholder="$t('device.device.023557-3')" v-model="query.deviceCode"></Input>
      </div>
      <Button type="primary" icon="ios-search" @click="GetUserDeviceModels"
        >{{ $t('device.device.023557-4') }}</Button
      >
    </div>
    <VTabel
      :height="380"
      :columns="columns"
      :data="dataList"
      :loading="loading"
      @onSelect="onSelect"
    ></VTabel>
  </div>
</template>

<script>
import api from "../../../../../../api/request.js";
import Cookies from "js-cookie";
import VTabel from "@/components/components/VTable/index.vue";
import defaultData from "./columns.js";

const URL = {
  GetUserDeviceModels: "api/CommElecDevice/GetUserDeviceModels",
};

export default {
  components: {
    VTabel,
  },
  data() {
    return {
      loading: false,
      query: {
        mobile: "",
        deviceCode: "",
      },
      dataList: [],
      selectDataList: [],
    };
  },
  mounted() {},
  computed: {
    columns() {
      return defaultData.columns(this);
    },
    shows: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      },
    },
  },
  methods: {
    GetUserDeviceModels() {
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `${URL.GetUserDeviceModels}?mobile=${this.query.mobile}&deviceCode=${this.query.deviceCode}&deviceType=qg`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token"),
          },
        },
        "yhj"
      ).then((res) => {
        if (res.Success) {
          this.dataList = res.Data || [];
        } else {
          this.$Message["error"]({
            background: true,
            content: res.Message,
          });
        }
      });
    },
    onSelect(list) {
      this.selectDataList = [...list];
    },
    submit() {
      return [...this.selectDataList]
    },
  },
};
</script>

<style scoped="scoped">
.btn-view {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 15px;
}
.from-view {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.from-label {
  width: 120px;
  text-align: right;
  font-weight: bold;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/useGas/views/device/mods/device/device.vue